"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[729],{

/***/ 90729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhyChooseCS_Banner; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
;// CONCATENATED MODULE: ./containers/WhyChooseCS/Banner/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 420px;\n  @media only screen and (max-width: 768px) {\n    height: 394px;\n  }\n  @media only screen and (max-width: 560px) {\n    height: 340px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b514897c-0"
})(_templateObject());

// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(30023);
;// CONCATENATED MODULE: ./containers/WhyChooseCS/Banner/index.js




var Banner = function() {
    var isMobile = (0,hooks/* useWindowDimensions */.dz)().isMobile;
    var imgPath = !isMobile ? "/images/why_choose_classy_closets/why_choose_us_banner-mobile.webp" : "/images/why_choose_classy_closets/why_choose_us_banner-mobile.webp";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: "why choose us banner",
            src: imgPath,
            layout: "fill",
            objectFit: "cover",
            loading: "lazy",
            quality: 70
        })
    });
};
/* harmony default export */ var WhyChooseCS_Banner = (Banner);


/***/ })

}]);